import { connect } from 'react-redux';
import {
  updateSavingPlan,
  requestProductDetail,
  requestProductOffers,
  requestGeneratePayment,
  requestGenerateCheckoutPayment,
  updateCredentials,
  updateProduct,
  createSavingGoal,
  requestVerifyUser,
  requestCheckoutDetail,
} from 'src/redux/actions';
import OneTimeTransactions from './oneTimeTransactions';

function mapStateToProps(state) {
  return {
    user: state.user,
    savingPlan: state.savingPlan,
    checkout: state.checkout,
    product: state.product,
    partner: state.partner,
  };
}

export default connect(mapStateToProps, {
  updateSavingPlan,
  requestProductDetail,
  requestProductOffers,
  requestGeneratePayment,
  requestGenerateCheckoutPayment,
  updateCredentials,
  updateProduct,
  createSavingGoal,
  requestVerifyUser,
  requestCheckoutDetail,
})(OneTimeTransactions);
